import { FC } from 'react';

import { SearchBar } from '@components/index';

interface MembersTabHeaderProps {
  totalCount: number;
  selectedCount: number;
  searchTerm: string;
  onSearch: (value: string) => void;
}

const MembersTabHeader: FC<MembersTabHeaderProps> = ({
  totalCount,
  selectedCount,
  searchTerm,
  onSearch
}) => (
  <div className="flex items-center justify-between">
    <div className="flex items-center gap-x-10">
      <div className="flex items-center gap-x-2">
        <div className="text-xl font-medium text-content">Members</div>
        <div className="rounded-10 bg-bgBase px-2.5 text-content">
          {totalCount}
        </div>
      </div>
      <SearchBar
        placeholder="Search by name"
        value={searchTerm}
        onSearch={onSearch}
        searchBarStyle="w-96"
      />
    </div>
    <div className="flex items-center gap-x-1 rounded-full bg-primaryLite1 px-2 py-1.5">
      <div className="text-sm text-content">Selected</div>
      <div className="flex min-w-5 items-center justify-center rounded-full bg-primary px-1 py-0.5 text-sm leading-4 text-white">
        {selectedCount}
      </div>
    </div>
  </div>
);

export default MembersTabHeader;
